import { Theme } from '@mui/material/styles';

const getInputUnderlineRules = (theme: Theme) => {
  const underlineColor = theme.palette.warning.main;

  return {
    '&:before': {
      borderBottom: `1px solid ${underlineColor}`,
    },
    '&:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: `2px solid ${underlineColor}`,
    },
    '&:after': {
      borderBottomColor: underlineColor,
    },
  };
};

export const getRequiredUnderlineSx = (theme: Theme) => ({
  ...getInputUnderlineRules(theme),
  '&.Mui-focused:after': {
    borderBottomColor: theme.palette.warning.main,
  },
});

export const getRequiredUnderlineTextFieldSx = (theme: Theme) => ({
  '& .MuiInput-root': {
    ...getInputUnderlineRules(theme),
    '&.Mui-focused:after': {
      borderBottomColor: theme.palette.warning.main,
    },
  },
});
